import { defineMessage } from 'services/localization';

export const messages = {
    payDescription: defineMessage('pay_approved_bills_directly_from_approvalmax'),
    captureDescription: defineMessage('say_goodbye_to_manual_d_ages_or_pdfs_in_seconds'),
    tryNowButtonText: defineMessage('try_now'),
};
